import UserFormStep5 from "../user-stepper/UserFormStep5";
import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { CustomAxiosRequestConfig, axiosPrivate } from "../../api/axios";
import {
  CORE_CITY,
  CORE_CITY_NO_ID,
  CORE_PROVINCE,
  GET_FILE,
  STORE_STORES,
} from "../../api/apiClient";
import { IFormData } from "../seller-stepper/SellerStepper";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import customZ from "../../utils/setZodCustomMessages";
import { notEmptyField } from "../../utils/customSchemas";

import {
  PRODUCT_CLASSIFY_TYPE,
  STORE_PRODUCT_GROUP,
} from "../../api/apiClient";
import { Helmet } from "react-helmet";

const step2Schema = customZ.object({
  name: notEmptyField,
});

const ShopsPage = ({ isInUserForm, setEnteredUser, enteredUser }: any) => {
  const { setValue, getValues, watch } = useForm<IFormData>({
    resolver: (data, context, options) => {
      return zodResolver(step2Schema)(data, context, options);
    },
  });

  const access_token = localStorage.getItem("access_token");
  const [sellerForm2Info, setSellerForm2Info] = useState<any>(undefined);
  const [city, setCity] = useState([
    { name: "", id: 1, city: 1, prefix_number: "021" },
  ]);

  useEffect(() => {
    if (
      city[
        city.findIndex((obj: any) => obj["id"] === Number(getValues("city")))
      ] !== undefined
    ) {
    } else {
    }
  }, [getValues("city")]);

  const getProvince = async () =>
    axiosPrivate
      .get(
        CORE_PROVINCE,

        {
          withCredentials: true,
        }
      )
      .then((res) => res.data.data.result);

  const provinceMutation = useMutation({
    mutationFn: () => getProvince(),
    onSuccess(data, variables, context) {},
  });

  const getAllCity = async () =>
    axiosPrivate
      .get(CORE_CITY_NO_ID, {
        withCredentials: true,
      })
      .then((res) => res.data.data.result);

  const findProvinceMutation = useMutation({
    mutationFn: () => getAllCity(),
    onSuccess(data: any, variables, context) {},
  });

  useEffect(() => {
    if (sellerForm2Info) {
      findProvinceMutation.mutate();
    }
  }, [sellerForm2Info, provinceMutation.isSuccess]);

  const getSellerForm2Info = async () => {
    const data: { [key: string]: string | number | undefined } = {};
    try {
      const response = await axiosPrivate.get(STORE_STORES, {
        withCredentials: true,
        params: data,
      });

      setSellerForm2Info(response?.data.data);
      if (response?.status >= 200 && response?.status < 300) {
      } else {
      }
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    getSellerForm2Info();
    findProvinceMutation.mutate();
    provinceMutation.mutate();
  }, []);

  useEffect(() => {
    setValue("name", sellerForm2Info?.name);
    setValue("telephone_number", sellerForm2Info?.telephone_number);
    setValue(
      "phone_number_sec",
      sellerForm2Info?.phone_number_sec ? sellerForm2Info?.phone_number_sec : ""
    );
    setValue("postal_code", sellerForm2Info?.postal_code);
    setValue("address", sellerForm2Info?.address);
    setValue("store_doc_img", sellerForm2Info?.store_doc_img);
    setValue("store_image", sellerForm2Info?.store_image);
    setValue("city", String(sellerForm2Info?.city));
    setValue("logo", sellerForm2Info?.logo_uid);
  }, [setValue, sellerForm2Info]);

  const fetchImageDoc = async () => {
    try {
      const response = await axiosPrivate.get(
        GET_FILE(sellerForm2Info?.store_doc_img),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },

          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Error fetching image data:", error);
    }
  };

  const fetchImageStore = async () => {
    try {
      const response = await axiosPrivate.get(
        GET_FILE(sellerForm2Info?.store_image),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      if (response?.status >= 200 && response?.status < 400) {
      }
    } catch (error) {
      console.error("Error fetching image data:", error);
    }
  };

  const fetchImageLogo = async () => {
    try {
      const response = await axiosPrivate.get(
        GET_FILE(sellerForm2Info?.logo_uid),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },

          withCredentials: true,
        }
      );
      if (response?.data?.data?.urk !== null) {
      }
    } catch (error) {
      console.error("Error fetching image data:", error);
    }
  };

  useEffect(() => {
    sellerForm2Info && fetchImageDoc();
    sellerForm2Info && fetchImageStore();
    sellerForm2Info && fetchImageLogo();
  }, [
    sellerForm2Info?.store_image,
    sellerForm2Info?.store_doc_img,
    sellerForm2Info?.logo_uid,
  ]);

  function cityAdder(data: any) {
    for (let i = 0; i < data.length; i++) {
      data[i]["city"] = data[i]["id"];
    }
    return data;
  }
  const getCityTest = (id: number) =>
    axiosPrivate
      .get(
        CORE_CITY(id),

        {
          withCredentials: true,

          globalErrorHandler: false,
        } as CustomAxiosRequestConfig
      )
      .then((res) => cityAdder(res.data.data.result));
  const cityMutate = useMutation({
    mutationFn: (id: any) => getCityTest(0),
    onSuccess(data, variables, context) {
      setCity(data);
    },
  });

  useEffect(() => {
    getValues("id") !== undefined &&
      watch("id") !== "undefined" &&
      cityMutate.mutate(watch("id"));
  }, [watch("id"), getValues("id")]);

  const getProductList = () =>
    axiosPrivate
      .get(STORE_PRODUCT_GROUP)

      .then((res) => res?.data?.data?.result);

  const getProductTypes = (product_group_uid: string) =>
    axiosPrivate
      .get(PRODUCT_CLASSIFY_TYPE(product_group_uid), {
        headers: {
          // prettier-ignore
          "accept": "application/json",
          // prettier-ignore
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
        globalErrorHandler: false,
      } as CustomAxiosRequestConfig)
      .then((res) => res?.data?.data?.result);

  const getStoreProductLists = useMutation({
    mutationFn: () => getProductList(),
    onSuccess(data, variables, context) {},
    onError() {
      console.error("error in fetching data (productGroup)");
    },
  });

  useEffect(() => {
    getStoreProductLists.mutate();
  }, []);

  const productTypeListMutation = useMutation({
    mutationFn: (product_group_uid: string) =>
      getProductTypes(product_group_uid),
    onSuccess(data, variables, context) {},
    onError() {
      console.error("error in fetching data (productttype)");
    },
  });

  useEffect(() => {
    if (watch("product_group_uid") !== undefined) {
      productTypeListMutation.mutate(watch("product_group_uid"));
    }
  }, [watch("product_group_uid")]);



  return (
    <div
      className={`pt-4 gap-2 z-10 flex justify-center mx-auto mb-10 md:flex-row flex-col`}
    >
      <Helmet>
        <title>فروشگاه های وامسی</title>
        <meta name="description" content="فروشگاه های وامسی" />
        <link rel="canonical" href="https://vam30.com/shops" />
      </Helmet>
      <UserFormStep5
        setEnteredUser={setEnteredUser}
        enteredUser={enteredUser}
        isInUserForm={isInUserForm}
        ctw={watch("city")}
        prvncw={watch("id")}
      />
    </div>
  );
};

export default ShopsPage;
